import { columnName, tableName } from 'app/area/case/case-data-model';

const log = columnName[tableName.involvedPersonInside];

type FieldReader<T> = (row: T, field: string) => any;

/**
 * Store reader: `row[field][0].value`
 */
export const readStoreField: FieldReader<any> = (row, field) => row?.[field]?.[0]?.value;

/**
 * The first entry that has no egress time, i.e. the person is still inside.
 */
export const findOpenEntry = <T>(entries: T[] | undefined, read: FieldReader<T>): T | undefined =>
  (entries ?? []).find(entry => !read(entry, log.egressTime));

/**
 * A new entry can be added when there are no entries at all,
 * or when every entry has an egress time. Mirrors the disabled state of the add button
 * in the entry log tile view (withAddDisabledUntilEgressed).
 */
export const canAddEntry = <T>(entries: T[] | undefined, read: FieldReader<T>): boolean =>
  !findOpenEntry(entries, read);
